var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "./Badge.css";
function Badge(props) {
    var _a, _b;
    var checkTextColor = (_a = props.text_color) !== null && _a !== void 0 ? _a : "text-dark";
    var checkBgColor = (_b = props.bg_color) !== null && _b !== void 0 ? _b : "text-white";
    return (_jsx("div", __assign({ className: "badge-style " + checkTextColor + " " + checkBgColor }, { children: props.title }), void 0));
}
export default Badge;



//////////////////
// WEBPACK FOOTER
// ./src/components/Badge.tsx
// module id = 67
// module chunks = 0